<template>
  <div class="main-box">
    <div class="detail-box-header">
      <div class="header-left">
        <span>您当前所在位置 >  </span>
        <el-breadcrumb separator=">" style="margin-left: 4px" >
          <el-breadcrumb-item>考试中心</el-breadcrumb-item>
          <el-breadcrumb-item>实训数据</el-breadcrumb-item>
          <el-breadcrumb-item>网店客户服务</el-breadcrumb-item>
          <el-breadcrumb-item>{{detailData.score_operate}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="header-right">
        <el-button @click="toBack" type="primary">返回</el-button>
      </div>
    </div>
    <StoreServiceScoreDetail :detailData="detailData" />
  </div>
</template>

<script>
import StoreServiceScoreDetail from '@/components/teacher/examCenter/examData/StoreServiceScoreDetail.vue'
export default {
  name: "StoreCustomerPracticalDetail",
  components:{
    StoreServiceScoreDetail
  },
  data(){
    return {
      detailData:{}
    }
  },
  mounted() {
    this.detailData = JSON.parse(localStorage.getItem('issueItem'))
  },
  methods:{
    toBack(){
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-breadcrumb{
  .el-breadcrumb__inner{
    color: #2C95FF;
  }
  .el-breadcrumb__separator{
    color: #333333;
    font-weight: 500;
  }
}
.main-box{
  height: 100%;
  display: flex;
  flex-direction: column;
  .detail-box-header{
    margin: 0 20px;
    padding: 0px 0 14px;
    display: flex;
    justify-content: space-between;
    border-bottom: 2px solid #F1F5FF;
    .header-left{
      display: flex;
      align-items: center;
      span{
        line-height: 1;
      }
    }
  }
}
</style>